'use strict';
angular.module('schoolLinqApp').factory('accountCategoryService', [
	'$http',
	function ($http) {
		var endpoint = '/api/account-categories';
		var subcategoryEndpoint = '/api/account-subcategories';

		function getCategories() {
			return $http.get(endpoint);
		}

		function getAllSubcategories() {
			return getSubcategories(null);
		}

		function getSubcategories(categoryId) {
			return $http.get(subcategoryEndpoint, {
				params: { categoryId: categoryId },
			});
		}

		function addCategory(categoryDescription) {
			return $http.post(endpoint, {
				Description: categoryDescription,
			});
		}

		function updateCategory(id, categoryDescription) {
			return $http.put(endpoint + '/' + id, {
				Id: id,
				Description: categoryDescription,
			});
		}

		function deleteCategory(id) {
			return $http.delete(endpoint + '/' + id);
		}

		function addSubcategory(categoryId, subcategoryDescription) {
			return $http.post(subcategoryEndpoint, {
				CategoryId: categoryId,
				Description: subcategoryDescription,
			});
		}

		function updateSubcategory(id, categoryId, subcategoryDescription) {
			return $http.put(subcategoryEndpoint + '/' + id, {
				Id: id,
				CategoryId: categoryId,
				Description: subcategoryDescription,
			});
		}

		function deleteSubcategory(id) {
			return $http.delete(subcategoryEndpoint + '/' + id);
		}

		return {
			getCategories: getCategories,
			getAllSubcategories: getAllSubcategories,
			getSubcategories: getSubcategories,
			addCategory: addCategory,
			updateCategory: updateCategory,
			deleteCategory: deleteCategory,
			addSubcategory: addSubcategory,
			updateSubcategory: updateSubcategory,
			deleteSubcategory: deleteSubcategory,
		};
	},
]);
